import { render, staticRenderFns } from "./q-read.vue?vue&type=template&id=97f7cb8e&scoped=true&"
import script from "./q-read.vue?vue&type=script&lang=js&"
export * from "./q-read.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f7cb8e",
  null
  
)

export default component.exports